export const environment = {
  production: false,
  apiUrl: 'https://api.psav.com/navigator/cc-processing/training4/',
  siteKey: '6LcDUsMZAAAAAA1Y0toX7DOtU2G0OzOjuAc6LdnL',
  secretKey: 'Encore_2023',
  envIndicator: 'D',
};
